import React from 'react';
import { Callout } from 'components/layout/Callout';

export interface IConfirmAddCalloutProps {
  popupOpen: boolean;
  closePopup: () => void;
  linkRef: React.RefObject<HTMLElement>;
  newTagName: string;
  onSubmit: () => void;
};

const preventPropogation = (e: React.MouseEvent<HTMLInputElement, MouseEvent>): void => {
  e.stopPropagation();
};

export function ConfirmAddCallout({ popupOpen, closePopup, linkRef, onSubmit, newTagName }: IConfirmAddCalloutProps) {
  return (
    <Callout showArrow={true} isOpen={popupOpen} onClose={closePopup} sourceRef={linkRef} placement="bottom">
      <div onClick={preventPropogation} className="dpc-tags-editor-callout">
        <div className="dpc-tags-editor-callout__text">Do you want to create new tag:</div>
        <div className="dpc-tags-editor-callout__tag-name">"{newTagName}"</div>
        <button className="dpc-tags-editor-callout__button dp-button dp-right" onClick={onSubmit}>
          Yes
        </button>
        <button className="dpc-tags-editor-callout__button dp-button dp-right" onClick={closePopup}>
          No
        </button>
      </div>
    </Callout>
  );
}
